'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
export var RotateClockwise;
(function (RotateClockwise) {
    RotateClockwise["Quarter"] = "90deg";
    RotateClockwise["Half"] = "180deg";
    RotateClockwise["ThreeQuarters"] = "270deg";
    RotateClockwise["QuarterReverse"] = "-90deg";
})(RotateClockwise || (RotateClockwise = {}));
export const StyledIcon = styled.svg(({ $fill, $rotateClockwise, $transition }) => ({
    fill: $fill ?? 'currentColor',
    transform: $rotateClockwise && `rotateZ(${$rotateClockwise})`,
    transition: $transition && `transform ${$transition}`,
}));
export const BaseIcon = ({ fill, rotateClockwise, transition, ...rest }) => {
    return (_jsx(StyledIcon, { "$fill": fill, "$rotateClockwise": rotateClockwise, "$transition": transition, ...rest }));
};
//# sourceMappingURL=BaseIcon.js.map